<template>
  <div class="login">
    <div class="site-logo">
    </div>
    <div class="login-container">
      <div :class="localClassName">
      </div>
      <div class="body">
        <div class="title">
          <h3 class="panel-title"><span class="strong">{{localTitle}}</span> 로그인</h3>
        </div>
        <div class="form">
          <el-form :model="loginForm" :rules="rules" status-icon ref="frm">
            <el-form-item label="" prop="userId">
              <el-input v-model.trim="loginForm.userId" placeholder="아이디" @keyup.enter.native="submitForm"></el-input>
              <!-- <template v-if="localUserType === 'S'">
                <el-input type="tel" maxlength="11" v-model.trim="loginForm.userId" placeholder="아이디" @keyup.enter.native="submitForm">
                  <template slot="prepend">K</template>
                </el-input>
              </template>
              <template v-else>
                <el-input v-model.trim="loginForm.userId" placeholder="아이디" @keyup.enter.native="submitForm"></el-input>
              </template> -->
            </el-form-item>
            <el-form-item label="" prop="userPw">
              <el-input type="password" v-model.trim="loginForm.userPw" placeholder="비밀번호" @keyup.enter.native="submitForm"></el-input>
            </el-form-item>
            <!-- <button type="button" class="btn btn-lg btn-primary btn-block" @click="submitForm" :disabled="isDisabled">로그인</button> -->
            <el-button class="btn-block" type="primary" :loading="isLoading" @click="submitForm" :disabled="isDisabled">로그인</el-button>
          </el-form>
        </div>
      </div>
    </div>
    <div v-if="localUserType === 'S'" class="user-join">
      <!-- <p class="notice-user-id">아이디는 가입시 인증받은 휴대번호입니다.</p>
      <p class="notice-user-id">최초 비밀번호는 휴대번호 뒷번호 4자리입니다.</p>
      <br /> -->
      <p>
        기존 휴대폰 번호로 로그인하신 분들은<br />
        아이디 앞에 K를 입력하시고 로그인 하십시오
      </p>
      <router-link class="join-user" :to="{name: 'AGREEMENT'}">회원 가입</router-link>
    </div>
  </div>
</template>

<script>

import axios from '@/modules/api-axios'

export default {
  name: 'Login',
  props: {
    className: {
      type: String,
      required: true
    },
    title: {
      type: String,
      required: true
    },
    userType: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      localClassName: `top ${this.className}-logo`,
      localTitle: this.title,
      loginForm: {
        userId: '',
        userPw: ''
      },
      key: '',
      isLoading: false,
      rules: {
        id: [
          { required: true, message: '아이디를 입력하세요.', trigger: 'blur' },
          { min: 3, max: 20, message: '최소 4자 이상 최대 15자까지 입력하십시오.' }
        ],
        pw: [
          { required: true, message: '비밀번호를 입력하십시오.', trigger: 'blur' },
          { min: 4, message: '최소 4자 이상 입력하십시오.' }
        ]
      }
    }
  },
  computed: {
    isDisabled () {
      return this.loginForm.userId.length < 4 || this.loginForm.userPw.length < 4
    },
    localUserType () {
      return this.userType
    }

  },
  created () {
    // this.generateKey()
  },
  methods: {
    generateKey () {
      axios.get('/login/rsa')
        .then(response => {
          this.key = response.data
        })
        .catch(() => {
        })
    },
    submitForm () {
      this.isLoading = true
      this.$refs.frm.validate(valid => {
        if (valid) {
          const user = {
            // id: (this.localUserType === 'S' ? 'K' : '') + this.loginForm.userId,
            id: this.loginForm.userId,
            pw: this.loginForm.userPw,
            user_type: this.localUserType,
            key: this.key
          }
          this.$store.dispatch('AUTH_REQUEST', user)
            .then(response => {
              this.isLoading = false
              const result = response.data
              // console.log('result : ', result)
              if (result.status === 1) {
                if (this.$route.query.q) {
                  this.$router.push({path: this.$route.query.q})
                } else {
                  this.$router.push({name: 'MAIN_' + this.userType})
                  // window.location.href = '/'
                }
              } else {
                // this.$message.warning({message: '아이디 또는 비밀번호를 다시 확인하세요.', showClose: true})
                this.$message.warning({message: result.message, showClose: true})
              }
            })
            .catch(error => {
              console.error('login error : ', error)
              this.isLoading = false
              // this.$message.error({message: '아이디 또는 비밀번호를 다시 확인하세요.', showClose: true})
            })
        } else {
          this.isLoading = false
        }
      })
    }
  }
}
</script>

<style scoped>
  .user-join {
    text-align: center;
    padding-top: 20px;
  }
  .notice-user-id {
    font-weight: 500;
    color: #292955;
  }
  .join-user {
    font-weight: bold;
    color: #8a2be2;
  }
</style>



// WEBPACK FOOTER //
// src/pages/Login.vue